import { render, staticRenderFns } from "./CheckDocsSent.vue?vue&type=template&id=60250b42"
import script from "./CheckDocsSent.vue?vue&type=script&lang=js"
export * from "./CheckDocsSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports